import { render } from "./addCard.vue?vue&type=template&id=2a6e6a24&scoped=true"
import script from "./addCard.vue?vue&type=script&lang=js"
export * from "./addCard.vue?vue&type=script&lang=js"

import "./addCard.vue?vue&type=style&index=0&id=2a6e6a24&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_Ejzw/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6e6a24"]])

export default __exports__